import $ from 'jquery'
import { createApp } from "vue"
import hljs from 'highlight.js'
import 'slick-carousel'
import Quiz from './quiz/quiz'
import UserFlashcards from '../flashcards_user/components/user_flashcards_app'
import { initMediaAsset } from './init_markup_asset_media'
import { embedPracticeGame } from 'practice_games_user/embed'
import { initSlideshow } from 'slideshow/index'
import { videoPopup } from 'shared/video_popup'

export function initMarkup($container) {
  setupMarkupQuiz($container)
  addSharedFacts($container)
  smoothScroll($container)
  markupVideoOverlay($container)
  toggleExpandable($container)
  initPracticeGame()
  initHighlightjs()
  initMarkupSlideshow($container)
  setupFlashcards($container)
  copySectionContent($container)

  $('.markup-media-asset', $container).each(function() {
    initMediaAsset($(this))
  })
}

function setupMarkupQuiz($section) {
  const quizzes = []

  $section.find(".quiz").replaceWith(function() {
    const $quiz = $(this)

    const dataText = $quiz[0].firstChild.data
    const quizResponse = JSON.parse(dataText)
    const questions = quizResponse.questions
    quizzes.push(questions)
    return $("<div class='m-quiz' />")
  })

  quizzes.forEach(questions => {
    const el = $section.find('.m-quiz').get(0)

    createApp(Quiz, { questions }).mount(el);
  })
}

function setupFlashcards($section) {
  const decks = []
  $section.find(".flashcards-markup-application").each(function() {
    const $deck = $(this)
    const deckId = $deck.data('id')

    decks.push({ deckId, el: $deck[0] }) // save the element DOM node
  })

  decks.forEach(({ deckId, el }) => {
    const xhr = {
      method: 'GET',
      url: '/flashcards/decks/' + deckId
    }

    SOPHIA.sendXHR(xhr).then(response => {
      createApp(UserFlashcards, { deck: response }).mount(el);
    })
  })
}

function markupVideoOverlay($mainContainer) {
  const $markupVideoLink = $('.markup-video-link', $mainContainer)

  $markupVideoLink.on('click', function () {
    const videoData = $(this).data("video-id"),
        $modal = $(".markup-video[id=" + videoData + "]");

    videoPopup($modal)
  })
}

function initMarkupSlideshow($container) {
  setTimeout(() => {
    initSlideshow({slideshow: $container.find('.slideshow')})
  }, 1000)
}

function initPracticeGame() {
  embedPracticeGame()
}

function initHighlightjs() {
  hljs.highlightAll.called = false; // to reinit plugin without page reloading
  hljs.highlightAll();
}

function smoothScroll($container) {
  // to scroll inside current $container area
  $('#toc a[href^="#"]:not(.facts-link)', $container).on('click', function() {
    if ($('body').hasClass('tutorial-page')) {
      $('html, body').animate({
        scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]', $container).offset().top - 70 //'70' is height of sticky edit panel
      }, 500);
    }
  })

  // additional facts scroll by all page
  $('#toc a[href^="#"].facts-link', $container).on('click', function() {
    if ($('body').hasClass('tutorial-page')) {
      $('html, body').animate({
        scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]').offset().top - 40 //'40' just paddind for correct view
      }, 500);
    }
  })

  if ($('html').hasClass('milestone-html')) {
    // trigger window resize to adjust the sticky header
    if (window.location.hash) {
      // wait until browser has scrolled to the anchor
      setTimeout(function() {
        $(window).trigger('resize');
      }, 100);
    }
    $('#toc a[href^="#"]', $container).on('click', () => {
      // trigger when click a TOC link
      $(window).trigger('resize')
    })
  }
}

function toggleExpandable($container) {
  const $expandableLink = $('.markup-expandable-title', $container)
  $expandableLink.off('click')
  $expandableLink.off('keydown')

  $expandableLink.on('click', function (event) {
    toggleAccordion(event);
  })

  $expandableLink.on('keydown', function(event) {
    if (event.keyCode == $.ui.keyCode.ENTER) {
      toggleAccordion(event);
    }
  })
}

function toggleAccordion(event) {
  event.preventDefault();

  const $item = $(event.currentTarget).closest('.markup-expandable')
  const $itemAnswer = $(event.currentTarget).siblings('.markup-expandable-content')
  let eventAction

  if ($item.hasClass('expanded')) {
    $item.removeClass('expanded')
    $itemAnswer.slideUp()
    eventAction = 'collapse'
  } else {
    $item.addClass('expanded')
    $itemAnswer.slideDown()
    eventAction = 'expand'
  }

  SOPHIA.clickToggleForGA({
    el: $('a', $item),
    eventAction,
    moduleName: 'Markup expandable element',
    fieldType: 'drawer'
  })
}

function addSharedFacts($container) {
  const $toc = $('#toc', $container)
  const $facts = $('.shared-facts-wrapper')

  if ($toc.length && $facts.length) {
    $('td' ,$toc).append('<ul class="shared-facts-additional-list"></ul>')

    $('.shared-facts-wrapper').each(function(index) {
      let sharedIcon = $('.box-header-icon i', $(this)).attr('class')
      let sharedText = $('.box-header-text', $(this)).text().trim()
      let sharedFactsId = 'shared_facts_'+index
      let hrefLink = '<a href="#'+sharedFactsId+'" class="facts-link"><i class="'+sharedIcon+'"></i>'+sharedText+'</a>'
      let anchor = '<a name="'+sharedFactsId+'"></a>'

      $('.box-header-text', $(this)).prepend(anchor)

      $('.shared-facts-additional-list' ,$toc).append('<li class="shared-facts-additional">'+hrefLink+'</li>')
    })
  }
}

function copySectionContent($container) {
  $container.on('click', '.copy-icon', function (e) {
    e.preventDefault()
    const $icon = $(this).find('i')
    const $block = $icon.closest('.copy-textblock')
    const $tooltip = $block.find('.copy-tooltip')
    const $text = $block.find('.copy-text')

    $tooltip.css('opacity', '0') // Hide the tooltip immediately

    // Get all text inside the block, excluding the icon and tooltip
    const textToCopy = $text.text().trim()

    // Function to handle icon/tooltip update
    const showCopySuccess = () => {
      $icon.removeClass('fa-copy').addClass('fa-check') // Change icon
      setTimeout(() => $icon.removeClass('fa-check').addClass('fa-copy'), 3000)
      $tooltip.css('opacity', '')
    }

    // Try to use modern Clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy)
        .then(showCopySuccess)
        .catch(() => fallbackCopy(textToCopy, showCopySuccess))
    } else {
      fallbackCopy(textToCopy, showCopySuccess)
    }
  })

  // Fallback for old browsers / mobile Safari
  function fallbackCopy(text, callback) {
    const $temp = $('<textarea>').val(text).css({ position: 'absolute', left: '-9999px' })
    $('body').append($temp)
    $temp.select()
    try {
      document.execCommand('copy')
      callback()
    } catch (err) {
      console.error('Fallback copy failed:', err)
    }
    $temp.remove()
  }
}

